<template>
  <div>
    <heads></heads>
    <div class="messenger-center">
      <div class="messenger-border" style="border: none">
        <div class="messengerCen">
          <div class="messenger-logo">
            <!-- <div class="logo-kf"><img :src="globalConfig.logoUrl"/></div>-->
            <div class="logo-title">
              <div v-for="item in tip" v-html="item.content"></div>
            </div>
          </div>
          <div class="messenger-list">
            <div v-for="item in list" @click.stop="_goOnline(item.id,item.name,item.avatar)">
              <span class="lineIcon"><img :src="globalConfig.imgUrl+item.avatar"/></span>
              <span class="messengerName"><em>{{item.name}}</em></span>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
  import heads from '../navs/headr'
    export default {
        name: "customer",
      components:{
        heads,
      },
      data(){
          return{
            list:[],
            tip:[],
          }
      },
      created:function(){
          let _self=this;
          _self._customer();
          _self._customerTip()
      },
      methods:{
        _customerTip:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'article/9', {}, function (result) {
            if(result.data['status_code']==200){
              _self.tip=result.data['data'];
            }
          })
        },
        _customer:function () {
          let _self=this;
          this._PublicFun.getData('1', 'get', 'customer', {}, function (result) {
            if(result.data['status_code']==200){
              _self.list=result.data['data'];
            }

          })
        },
        _goOnline:function(id,name,avatar){
          let _self=this;
          _self.$router.push({path:'/Online/'+id+"?name="+name+'&avatar='+avatar})

        },
      }
    }
</script>

<style scoped>
  @import "../../assets/css/messenger.css";
  .messenger-center{
    margin: 10px auto;
  }
  .messenger-list div{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/customer.vue